import { IFeatureFlagEvaluationMap } from 'lib_ts/interfaces/feature-flags/i-feature-flag';
import { FeatureFlagsService } from 'services/feature-flags.service';
import { create } from 'zustand';

type FeatureFlagsState = {
  /** server-evaluated map for the current user; fetched once post-auth */
  flags: IFeatureFlagEvaluationMap;
  loaded: boolean;
};

type FeatureFlagsActions = {
  /** fetch + cache the evaluated flag map (fail closed on error) */
  fetchFlags: () => Promise<void>;
  /** clear on logout so a stale map never lingers into an anon session */
  reset: () => void;
};

type FeatureFlagsStore = FeatureFlagsState & FeatureFlagsActions;

const useFeatureFlagsStore = create<FeatureFlagsStore>((set) => ({
  flags: {},
  loaded: false,

  fetchFlags: async () => {
    const flags = await FeatureFlagsService.getInstance().evaluate();
    set({ flags, loaded: true });
  },

  reset: () => set({ flags: {}, loaded: false }),
}));

export default useFeatureFlagsStore;
